import { Button, DialogActions, DialogTitle } from "@mui/material";
import axios, { AxiosError } from "axios";
import { useSnackbar } from "notistack";
import { useMutation } from "react-query";
import { queryClient } from "../App";
import { API_URL } from "../consts";

export function DeleteTipologiaUso(props: { id: number; closeDialog: () => void }) {
  const { closeDialog, id } = props;

  const { enqueueSnackbar } = useSnackbar();

  const { mutate } = useMutation(
    (data: { id: number }) => {
      return axios.delete(API_URL + "tipologie-uso/" + data.id);
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Tipologia Uso Eliminata", { variant: "success" });
        closeDialog();
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(error?.response?.data?.error ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  return (
    <>
      <DialogTitle>Sei sicuro di voler eliminare?</DialogTitle>
      <DialogActions>
        <Button color="warning" onClick={() => mutate({ id })}>
          Elimina
        </Button>
        <Button onClick={closeDialog} autoFocus>
          Chiudi
        </Button>
      </DialogActions>
    </>
  );
}
